import { useEffect, useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { CgClose } from 'react-icons/cg'
import axiosClient from '../config/axios-client'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer, toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router'
import { Link } from 'react-router-dom'
import { FaSpinner } from 'react-icons/fa'

export default function FormPage() {
  const navigate = useNavigate()

  const [files, setFiles] = useState([{ id: uuidv4(), name: null, file: null }])
  const [files2, setFiles2] = useState([{ id: uuidv4(), name: null, file: null }])
  const [countries, setCountries] = useState(null)
  const [uploadProgress, setUploadProgress] = useState(0)
  const [isSending, setIsSending] = useState(false)

  const countryRef = useRef(null)
  const concernedAuthorityRef = useRef(null)
  const fullNameRef = useRef(null)
  const emailRef = useRef(null)
  const phoneNumberRef = useRef(null)
  const professionRef = useRef(null)

  const handleAddFile = () => {
    setFiles([...files, { id: uuidv4(), name: '', file: null }])
  }

  const handleFileChange = (id, event) => {
    const newFiles = files.map((file) => (file.id === id ? { ...file, [event.target.name]: event.target.value } : file))
    setFiles(newFiles)
  }

  const handleFileUpload = (id, event) => {
    const newFiles = files.map((file) => (file.id === id ? { ...file, file: event.target.files[0] } : file))
    setFiles(newFiles)
  }

  const handleRemoveFile = (id) => {
    setFiles(files.filter((file) => file.id !== id))
  }

  const handleAddFile2 = () => {
    setFiles2([...files2, { id: uuidv4(), name: '', file: null }])
  }

  const handleFileChange2 = (id, event) => {
    const newFiles = files2.map((file) => (file.id === id ? { ...file, [event.target.name]: event.target.value } : file))
    setFiles2(newFiles)
  }

  const handleFileUpload2 = (id, event) => {
    const newFiles = files2.map((file) => (file.id === id ? { ...file, file: event.target.files[0] } : file))
    setFiles2(newFiles)
  }

  const handleRemoveFile2 = (id) => {
    setFiles2(files2.filter((file) => file.id !== id))
  }

  const uploadFiles = (countryUser) => {
    const mergedFiles = [...files, ...files2].filter((file) => file.file !== null || file.name !== null)

    const uploadPromises = mergedFiles.map((file) => {
      const filePayload = {
        country_user_id: countryUser.id,
        file: file.file,
        type: file.name,
      }

      return axiosClient
        .post(`/platform/form/countries-users/${countryUser.id}/file`, filePayload, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            setUploadProgress((prevProgress) => ({
              ...prevProgress,
              [file.id]: percentCompleted,
            }))
          },
        })
        .then(({ data }) => {
          toast.success(`!تم رفع الملف ${file.file.name}  بنجاح`)
          return true // Return true on success
        })
        .catch((error) => {
          toast.error(error.data?.error || 'File upload failed')
          return false // Return false on failure
        })
    })

    Promise.all(uploadPromises).then((results) => {
      // Check if all uploads were successful
      if (results.every((result) => result === true)) {
        // Clear files
        resetInputs()
        navigate(`/ar/not-found`)
      }
    })
  }

  const handleSubmitButton = () => {
    setIsSending(true)
    const payload = {
      country_id: countryRef.current.value,
      title: concernedAuthorityRef.current.value,
      full_name: fullNameRef.current.value,
      email: emailRef.current.value,
      phone_number: phoneNumberRef.current.value,
      profession: professionRef.current.value,
    }
    axiosClient
      .post('/platform/form/countries-users', payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(({ data }) => {
        uploadFiles(data.user)
      })
      .catch((error) => {
        if (!error.response && !error.request) {
          toast.error('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
        } else if (error.response) {
          toast.error(error.response.data.error)
        } else if (error.request) {
          toast.error('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
        } else {
          toast.error('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
        }
      })
      .finally(() => {
        setIsSending(false)
      })
  }

  const resetInputs = () => {
    setFiles([{ id: uuidv4(), name: null, file: null }]) // Reset files
    setFiles2([{ id: uuidv4(), name: null, file: null }]) // Reset files2
    // Clear input fields
    countryRef.current.value = ''
    concernedAuthorityRef.current.value = ''
    fullNameRef.current.value = ''
    emailRef.current.value = ''
    phoneNumberRef.current.value = ''
    professionRef.current.value = ''
  }

  const getCountries = () => {
    axiosClient
      .get(`/platform/countries`)
      .then(({ data }) => {
        setCountries(data.countries)
      })
      .catch(() => {})
      .finally(() => {})
  }
  useEffect(() => {
    getCountries()
  }, [])

  return (
    <div
      dir="rtl"
      className="app-container px-4 lg:px-0"
    >
      <ToastContainer />
      <div className="mb-16 flex flex-col gap-4 text-sm">
        <div className="flex items-center justify-between py-[8px]">
          <div>
            <Link to={`/ar/home`}>
              <img
                src={`/assets/logos/app_logo.svg`}
                width={'70px'}
                alt="apfrm logo"
              />
            </Link>
          </div>
          <div>
            <Link to={`/ar/home`}>
              <img
                src={`/assets/logos/app_name.png`}
                width={'280px'}
                alt="apfrm logo"
              />
            </Link>
          </div>
          <div>
            <Link
              target="_blank"
              to={`https://aidsmo.org/`}
            >
              <img
                src={`/assets/logos/aidsmo_logo.webp`}
                width={'70px'}
                alt="apfrm logo"
              />
            </Link>
          </div>
        </div>

        <div className="bg-primary-600 py-2 text-center text-lg font-bold text-white">إستمارة تعبئة بيانات المعادن بالمنطقة العربية</div>

        <div className="flex flex-col gap-2">
          <div className="flex gap-4">
            <div className="flex w-full flex-col gap-1">
              <label
                className="font-bold"
                htmlFor="ID_COUNTRY_ID"
              >
                الدولة <span className="text-danger-600">*</span>
              </label>
              <select
                placeholder="اختر الدولة"
                ref={countryRef}
                className="border-2 border-muted-300 px-4 py-0.5 outline-none"
                id="ID_COUNTRY_ID"
              >
                <option value=""></option>
                {countries && countries?.map((country) => <option value={country.id}>{country.name_ar}</option>)}
              </select>
            </div>
            <div className="flex w-full flex-col gap-1">
              <label
                className="font-bold"
                htmlFor="ID_ENTITY"
              >
                الجهة المعنية <span className="text-danger-600">*</span>
              </label>
              <input
                id="ID_ENTITY"
                ref={concernedAuthorityRef}
                className="border-2 border-muted-300 px-4 py-[5px] outline-none"
                type="text"
              />
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex w-full flex-col gap-1">
              <label
                className="font-bold"
                htmlFor="ID_FULLNAME"
              >
                الاسم الكامل <span className="text-danger-600">*</span>
                <span className="font-normal"> (المسؤول عن تعبئة البيانات) </span>
              </label>
              <input
                ref={fullNameRef}
                className="border-2 border-muted-300 px-4 py-[5px] outline-none"
                type="text"
                id="ID_FULLNAME"
              />
            </div>
            <div className="flex w-full flex-col gap-1">
              <label
                className="font-bold"
                htmlFor=""
              >
                المهنة <span className="text-danger-600">*</span>
              </label>
              <input
                ref={professionRef}
                className="border-2 border-muted-300 px-4 py-[5px] outline-none"
                type="text"
              />
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex w-full flex-col gap-1">
              <label
                className="font-bold"
                htmlFor=""
              >
                البريد الإلكتروني <span className="text-danger-600">*</span> <span className="font-normal">(المسؤول عن تعبئة البيانات) </span>
              </label>
              <input
                ref={emailRef}
                className="border-2 border-muted-300 px-4 py-[5px] outline-none"
                type="text"
              />
            </div>
            <div className="flex w-full flex-col gap-1">
              <label
                className="font-bold"
                htmlFor="ID_PHONE"
              >
                الجوال <span className="font-normal">(المسؤول عن تعبئة البيانات) </span>
              </label>
              <input
                ref={phoneNumberRef}
                id="ID_PHONE"
                className="border-2 border-muted-300 px-4 py-[5px] outline-none"
                type="tel"
              />
            </div>
          </div>
        </div>
        <div className="mt-8">
          <h2 className="border-r-8 border-warning pr-2 text-2xl font-black">البيانات الفنية المطلوبة:</h2>
          <p>تجميع البيانات الفنية للمعادن و فرص استثمارها بالدول العربية لإدراجها بالمنصة العربية لمعادن المستقبل</p>
        </div>
        <div>
          <table className="mb-2 w-full items-start border border-primary-600 align-top">
            <thead>
              <th className="border-l border-white bg-primary-600 p-2 text-white">(1) معادن الطاقة النظيفة</th>
              <th className="border-l border-white bg-primary-600 p-2 text-white">(2) المعادن والصخور الصناعية</th>
              <th
                colSpan={2}
                className="border border-primary-600/70 bg-primary-600 p-2 text-white"
              >
                الفرص االستثمارية التعدينية للمعادن في الدول العربية
              </th>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  rowSpan={2}
                  className="border border-primary-600 p-2 align-top"
                >
                  <ul className="list-inside list-disc leading-7">
                    <li>
                      <span className="font-bold"> اسم ومكان الموقع/المكمن</span>
                      <span> (تحديد اسماء ومكان المواقع الرئيسية او المكامن التي يتوفر بها المعدن)</span>
                    </li>
                    <li>
                      <span className="font-bold">الوضع الجيولوجي</span>
                      <span> (يتم إضافة فقرة بسيطة ومختصرة عن البيئة الجيولوجية للمعدن بالدولة)</span>
                    </li>
                  </ul>
                </td>
                <td className="border border-primary-600 p-2 align-top">(1) معادن الطاقة النظيفة</td>
                <td className="border border-primary-600 p-2 align-top">(2) المعادن والصخور الصناعية</td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  className="border border-primary-600 p-2 align-top"
                >
                  <ul className="list-inside list-disc leading-7">
                    <li>اسم الموقع</li>
                    <li>الخام</li>
                    <li>المساحة (كيلومتر مربع)</li>
                    <li>تاريخ الفرصة</li>
                    <li>نوع الفرصة</li>
                  </ul>
                  <u>بالإضافة الى امكانية رفع ملف كامل عن الفرصة Pdf</u>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="flex flex-col gap-2">
          <h4 className="text-warning">صيغة الملفات المدعمة: ملف Excel للمعلومات الفنية وPdf لمرفقات الفرص الاستثمارية</h4>
          {files2.map((fileInput) => (
            <>
              <div
                key={fileInput.id}
                className="flex w-full gap-2"
              >
                <select
                  type="text"
                  name="name"
                  placeholder="اسم الملف"
                  className="w-3/12 border border-primary-600 px-2 py-[0.5px]"
                  value={fileInput.name}
                  onChange={(e) => handleFileChange2(fileInput.id, e)}
                >
                  <option value="">اسم الملف </option>
                  <option value="البيانات الفنية لمعادن الطاقة النظيفة"> (Excel) البيانات الفنية لمعادن الطاقة النظيفة </option>
                  <option value="البيانات الفنية للمعادن والصخور الصناعية">(Excel) البيانات الفنية للمعادن والصخور الصناعية</option>
                  <option value="الفرص الاستثمارية التعدينية لمعادن الطاقة النظيفة">(Excel) الفرص الاستثمارية التعدينية لمعادن الطاقة النظيفة</option>
                  <option value="الفرص الاستثمارية التعدينية للمعادن والصخور الصناعية">(Excel) الفرص الاستثمارية التعدينية للمعادن والصخور الصناعية</option>
                  <option value="اضافة مرفقات للفرص الاستثمارية التعدينية">(Pdf) اضافة مرفقات للفرص الاستثمارية التعدينية</option>
                </select>
                <input
                  type="file"
                  name="file"
                  accept=".pdf,.xls,.xlsx,.csv"
                  className={`w-full bg-muted-300 px-2 py-[4px] outline-none`}
                  onChange={(e) => handleFileUpload2(fileInput.id, e)}
                />
                <button
                  type="button"
                  className="flex w-[40px] items-center justify-center bg-danger-600/70 px-2 py-[4px] text-white hover:bg-danger-600"
                  onClick={() => handleRemoveFile2(fileInput.id)}
                >
                  <CgClose />
                </button>
              </div>
              {uploadProgress[fileInput.id] && (
                <div className="relative mb-[16px] h-[16px] transform bg-muted-300 text-center text-white transition duration-150 ease-in">
                  <div className="flex h-full w-full items-center justify-center">
                    <div
                      style={{
                        width: `${uploadProgress[fileInput.id]}%`,
                      }}
                      className="absolute bottom-0 left-0 top-0 bg-success-600/50"
                    ></div>
                  </div>
                </div>
              )}
            </>
          ))}
          <button
            type="button"
            className="bg-muted-300 py-2 text-center"
            onClick={handleAddFile2}
          >
            إضافة ملف آخر
          </button>
        </div>

        <div className="mt-8">
          <h2 className="border-r-8 border-warning pr-2 text-2xl font-black">البيانات الجيومكانية المطلوبة:</h2>
          <p>تجميع البيانات الجيومكانية للمعادن بالدول العربية لإدراجها بالخريطة المعدة بنظم المعلومات الجغرافية Arc GIS Server بالمنصة العربية لمعادن المستقبل</p>
        </div>
        <div>
          <table className="mb-2 w-full border border-primary-600">
            <thead>
              <th
                className="border-l border-white bg-primary-600 p-2 text-white"
                colSpan={2}
              >
                معادن المستقبل
              </th>
              <th className="border-l border-white bg-primary-600 p-2 text-white">المناجم</th>
              <th className="border-l border-white bg-primary-600 p-2 text-white">المصانع</th>
              <th className="border border-primary-600/70 bg-primary-600 p-2 text-white">الفرص الاستثمارية التعدينية</th>
            </thead>
            <tbody>
              <tr>
                <td className="border border-primary-600 p-2 align-top">معادن الطاقة النظيفة</td>
                <td className="border border-primary-600 p-2 align-top">المعادن والصخور الصناعية</td>
                <td
                  className="border border-primary-600 p-2 align-top"
                  rowSpan={2}
                >
                  <ul className="list-inside list-disc">
                    <li>اسم المنجم</li>
                    <li>الإحداثيات (X,Y)</li>
                    <li>معدل الانتاج السنوي</li>
                    <li>تاريخ بدء الإنتاج</li>
                    <li>الخام المستخرج</li>
                  </ul>
                </td>
                <td
                  className="border border-primary-600 p-2 align-top"
                  rowSpan={2}
                >
                  <ul className="list-inside list-disc">
                    <li>اسم المصنع</li>
                    <li>الإحداثيات (X,Y)</li>
                    <li>معدل الانتاج السنوي</li>
                    <li>تاريخ بدء الإنتاج</li>
                    <li>المنتج</li>
                  </ul>
                </td>
                <td
                  className="border border-primary-600 p-2 align-top"
                  rowSpan={2}
                >
                  <ul className="list-inside list-disc">
                    <li>اسم الموقع</li>
                    <li>الخام</li>
                    <li>الإحداثيات (X,Y)</li>
                    <li>المساحة</li>
                    <li>نوع الفرصة </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="border border-primary-600 p-2 align-top">
                  <ul className="list-inside list-disc">
                    <li>اسم الموقع</li>
                    <li>الإحداثيات (X,Y)</li>
                    <li>رمز المعدن</li>
                    <li>المعادن المصاحبة</li>
                    <li>الصخور المحيطة</li>
                  </ul>
                </td>
                <td className="border border-primary-600 p-2 align-top">
                  <ul className="list-inside list-disc">
                    <li>اسم الموقع</li>
                    <li>الإحداثيات (X,Y)</li>
                    <li>رمز المعدن</li>
                    <li>الصخور المحيطة</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="flex flex-col gap-2">
          <h4 className="text-warning">صيغة الملفات المدعمة : Shape file (shp), Excel, CSV, mxd, aprx</h4>
          {files.map((fileInput) => (
            <>
              <div
                key={fileInput.id}
                className="flex w-full gap-2"
              >
                <select
                  type="text"
                  name="name"
                  placeholder="اسم الملف"
                  className="w-3/12 border border-primary-600 px-2 py-[0.5px]"
                  value={fileInput.name}
                  onChange={(e) => handleFileChange(fileInput.id, e)}
                >
                  <option value="">اسم الملف</option>
                  <option value="معادن الطاقة النظيفة">معادن الطاقة النظيفة</option>
                  <option value="المعادن والصخور الصناعية">المعادن والصخور الصناعية</option>
                  <option value="المناجم">المناجم</option>
                  <option value="المصانع">المصانع</option>
                  <option value="الفرص الاستثمارية التعدينية">الفرص الاستثمارية التعدينية</option>
                </select>
                <input
                  type="file"
                  name="file"
                  accept=".shp,.xls,.xlsx,.csv,.mxd,.aprx"
                  className={`w-full bg-muted-300 px-2 py-[4px] outline-none`}
                  onChange={(e) => handleFileUpload(fileInput.id, e)}
                />
                <button
                  type="button"
                  className="flex w-[40px] items-center justify-center bg-danger-600/70 px-2 py-[4px] text-white hover:bg-danger-600"
                  onClick={() => handleRemoveFile(fileInput.id)}
                >
                  <CgClose />
                </button>
              </div>
              {uploadProgress[fileInput.id] && (
                <div className="relative mb-[16px] h-[16px] transform bg-muted-300 text-center text-white transition duration-150 ease-in">
                  <div className="flex h-full w-full items-center justify-center">
                    <div
                      style={{
                        width: `${uploadProgress[fileInput.id]}%`,
                      }}
                      className="absolute bottom-0 left-0 top-0 bg-success-600/50"
                    ></div>
                  </div>
                </div>
              )}
            </>
          ))}
          <button
            type="button"
            className="mb-[16px] bg-muted-300 py-2 text-center"
            onClick={handleAddFile}
          >
            إضافة ملف آخر
          </button>
          <button
            disabled={isSending}
            onClick={handleSubmitButton}
            className="flex w-full items-start justify-center border-2 border-primary-600 bg-primary-600 p-3 font-bold text-white hover:border-secondary-600 hover:bg-secondary-600 disabled:cursor-not-allowed disabled:border-muted-300 disabled:bg-muted-100 disabled:text-dark"
          >
            {isSending ? (
              <div className="flex items-center">
                <FaSpinner
                  size={16}
                  className="ml-4 animate-spin"
                />
                <span>جاري إرسال...</span>
              </div>
            ) : (
              <span>إرسال</span>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
